module.exports = __webpack_public_path__ + "img/2.33c23792.png";